import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {catchError, map, of} from "rxjs";
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import {PartyRoadmapService} from "@portal/api/party-roadmap.service";
import {CollaboratorResponse} from "@portal/api/responses/collaborators/collaborator-response";
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-collaborators-selection-modal',
    templateUrl: './collaborators-selection-modal.component.html',
    styleUrls: ['./collaborators-selection-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CdkScrollable, MatDialogContent, MatFormField, MatSelect, FormsModule, MatOption, MatDialogActions, MatButton, MatDialogClose]
})
export class CollaboratorsSelectionModalComponent implements OnInit {
    selectedCollaboratorId: string;
    isUsersDropdownLoading: boolean;
    options: { label: string, value: string }[] = [];
    origin: string;
    originId: string;

    constructor(private _roadmapService: PartyRoadmapService,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.origin = data.origin;
        this.originId = data.originId;
    }

    ngOnInit(): void {
        this.loadOptions();
        this.selectedCollaboratorId = '';
    }

    loadOptions() {
        this.isUsersDropdownLoading = true;
        this._roadmapService.getCollaborators().pipe(
            catchError(() => of([])),
        ).pipe(
            map((response: CollaboratorResponse[]) =>
                response.map(option => ({label: `${option.name}`, value: option.id.toString()}))),
        ).subscribe((options) => {

                this.options = [...this.options, ...options];
            }, () => {
                this.isUsersDropdownLoading = false;
            },
            () => {
                this.options = this.options.filter((option, index) => {
                    return this.options.findIndex((otherOption) => {
                        return option.value === otherOption.value;
                    }) === index;
                });

                this.options = this.options.sort((a, b) => {
                    if (a.label.toLocaleUpperCase() < b.label.toLocaleUpperCase()) {
                        return -1;
                    }
                    if (a.label.toLocaleUpperCase() > b.label.toLocaleUpperCase()) {
                        return 1;
                    }
                    return 0;
                });
                this.isUsersDropdownLoading = false;
                this.options = [{label: 'Todos', value: ''}, ...this.options];
            });
    }

    onSelectChange(value: any) {
        this.selectedCollaboratorId = value;
    }
}
